import { useState, useEffect } from "react";
import { FileText, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { JUDETE } from "@/lib/judete";

const FIELDS = [
  ["name", "Nume complet"],
  ["phone", "Telefon"],
  ["city", "Localitate"],
  ["address", "Adresă (stradă, număr, bloc, ap.)"],
];

export const AwbCustomerDialog = ({ open, order, busy, onClose, onConfirm }) => {
  const [form, setForm] = useState(order.customer);
  useEffect(() => { if (open) setForm(order.customer); }, [open, order.customer]);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const valid = ["name", "phone", "address", "city", "county"].every((k) => (form[k] || "").trim());
  const short = order.id.slice(0, 8);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent className="max-w-lg" data-testid={`awb-dialog-${short}`}>
        <DialogHeader>
          <DialogTitle className="font-display font-black text-navy">Verifică datele clientului</DialogTitle>
          <DialogDescription>Corectează ce e greșit înainte de a genera AWB-ul Cargus.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {FIELDS.map(([k, label]) => (
            <label key={k} className="block">
              <span className="block text-sm font-bold text-navy mb-1">{label}</span>
              <input className="inp" value={form[k] || ""} onChange={set(k)} data-testid={`awb-edit-${k}`} />
            </label>
          ))}
          <label className="block">
            <span className="block text-sm font-bold text-navy mb-1">Județ</span>
            <select className="inp" value={form.county || ""} onChange={set("county")} data-testid="awb-edit-county">
              <option value="">Alege județul</option>
              {!JUDETE.includes(form.county) && form.county && <option value={form.county}>{form.county}</option>}
              {JUDETE.map((j) => <option key={j} value={j}>{j}</option>)}
            </select>
          </label>
          <label className="block">
            <span className="block text-sm font-bold text-navy mb-1">Observații</span>
            <textarea className="inp min-h-[60px]" value={form.notes || ""} onChange={set("notes")} data-testid="awb-edit-notes" />
          </label>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <button onClick={onClose} disabled={busy} className="px-4 py-2.5 rounded-xl bg-slate-100 hover:bg-slate-200 text-navy font-bold text-sm" data-testid="awb-dialog-cancel">
            Anulează
          </button>
          <button
            onClick={() => onConfirm(form)}
            disabled={busy || !valid}
            className="bg-eco hover:bg-green-700 disabled:opacity-60 text-white text-sm font-bold px-4 py-2.5 rounded-xl inline-flex items-center gap-2"
            data-testid="awb-dialog-confirm"
          >
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileText className="h-4 w-4" />} Salvează și generează AWB
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
